import React, { useState } from 'react'
import { LoginContainer } from '@/components/containers/login'
import { RouteComponentProps } from 'react-router-dom'

export const LoginPage: React.FC<RouteComponentProps> = () => {
  return <LoginContainer />
}
